import React from 'react';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import HeadingAndSupportingTextWithActions, {
  HeadingAndSupportingTextWithActionsProps,
} from '../HeadingAndSupportingText/HeadingAndSupportingTextWithActions';
import Button, { ButtonProps } from 'src/app/atoms/Button/Button';
import MediaCardCarousel from '../MediaCardCarousel/MediaCardCarousel';
import { MediaCardProps } from '../MediaCard/MediaCard';

interface MediaCardCarouselWithTextBlockProps {
  heading: HeadingAndSupportingTextWithActionsProps['heading'];
  supportingText?: HeadingAndSupportingTextWithActionsProps['supportingText'];
  button?: ButtonProps;
  cards: MediaCardProps[];
}

const MediaCardCarouselWithTextBlock = ({
  heading,
  supportingText,
  button,
  cards,
}: MediaCardCarouselWithTextBlockProps): JSX.Element => (
  <Stack
    direction='column'
    gap='spacing-4xl'
    gapSm='spacing-3xl'
  >
    <HeadingAndSupportingTextWithActions
      maxWidth='width-xl'
      heading={heading}
      supportingText={supportingText}
      actions={
        button && (
          <Stack hideOn='lg' maxWidth='width-fit-content'>
            <Button {...button} />
          </Stack>
        )
      }
    />
    <MediaCardCarousel cards={cards} />
    {button && (
      <Stack showOn='lg' maxWidth='width-fit-content'>
        <Button {...button} />
      </Stack>
    )}
  </Stack>
);

export default MediaCardCarouselWithTextBlock;
